import React from "react";
import { Link } from "react-router-dom";
import { track } from "../services/events";

interface RelatedLink {
  to: string;
  title: string;
  desc: string;
}

interface RelatedContentRailProps {
  title?: string;
  section: string;
  links: RelatedLink[];
}

export default function RelatedContentRail({
  title = "Related Content",
  section,
  links,
}: RelatedContentRailProps) {
  return (
    <aside className="lg:sticky lg:top-28 self-start rounded-2xl border border-slate-200 bg-slate-50 p-5">
      <p className="text-[10px] uppercase tracking-[0.2em] font-bold text-slate-500">{title}</p>
      <div className="mt-3 space-y-2">
        {links.map((link) => (
          <Link
            key={link.to + link.title}
            to={link.to}
            onClick={() =>
              track("related_content_click", {
                section,
                destination: link.to,
                title: link.title,
              })
            }
            className="block rounded-xl border border-slate-200 bg-white px-3 py-3 hover:border-indigo-300 hover:bg-indigo-50/40 transition"
          >
            <p className="text-sm font-semibold text-slate-900">{link.title}</p>
            <p className="text-xs text-slate-600 mt-1 leading-relaxed">{link.desc}</p>
          </Link>
        ))}
      </div>
    </aside>
  );
}
